<template>
  <div>
    <v-card>
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách thiết bị"
          v-model="table.searchText"
          v-on:keyup.enter="search()"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="exportToExcel()">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>Tải về danh sách thiết bị</span>
        </v-tooltip>
        <v-menu offset-y origin="center center" :nudge-bottom="10" :close-on-content-click="false" v-if="isFilter" max-height="calc(100vh - 180px)">
          <v-btn icon slot="activator">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-card>
            <v-card-title>
              Bộ lọc
              <v-spacer></v-spacer>
              <!-- <v-btn icon color="info" class="my-0" @click="filterData">
                <v-icon>arrow_drop_down</v-icon>
              </v-btn> -->
              <v-btn color="info" slot="activator" @click="filterData">Áp dụng</v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p class="filter-title">Loại thiết bị</p>
              <v-radio-group v-model="params.deviceTypeFilter" column>
                <v-radio label="Tất cả" value="All"></v-radio>
                <v-radio label="MT10" value="MT10"></v-radio>
                <v-radio label="MT20" value="MT20"></v-radio>
                <v-radio label="MT20A" value="MT20A"></v-radio>
                <v-radio label="MT20B" value="MT20B"></v-radio>
                <v-radio label="MT20C" value="MT20C"></v-radio>
                <v-radio label="MTP8" value="MTP8"></v-radio>
                <v-radio label="MTP9" value="MTP9"></v-radio>
                <v-radio label="MT30" value="MT30"></v-radio>
                <v-radio label="MT99" value="MT99"></v-radio>
              </v-radio-group>
              <v-divider></v-divider>
              <p class="filter-title">Gói cước</p>
              <v-radio-group v-model="params.planCodeFilter" column>
                <v-radio label="Tất cả" value="All"></v-radio>
                <v-radio label="MOTO1T" value="MOTO1T"></v-radio>
                <v-radio label="MOTO1Y" value="MOTO1Y"></v-radio>
                <v-radio label="MOTOTR" value="MOTOTR"></v-radio>
              </v-radio-group>
              <v-divider></v-divider>
              <p class="filter-title">Trạng thái thiết bị</p>
              <v-radio-group v-model="params.activedFilter" column>
                <v-radio label="Tất cả" value="All"></v-radio>
                <v-radio label="Thiết bị đã kích hoạt" value="Actived"></v-radio>
                <v-radio label="Thiết bị chưa kích hoạt" value="NotActived"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :items="datasourceFiltered"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
          :pagination.sync="paginationSync"
          @update:pagination="changePage"
          :total-items="totalItems"
        >
          <template slot="items" slot-scope="props">
            <tr @contextmenu.prevent="openContextMenu($event, props.item)">
              <td>{{ props.item.dealerName }}</td>
              <v-btn
                flat
                round
                small
                color="primary"
                :to="getAccountDetailLink(props.item.accountId)"
                class="link-button account-name"
              >{{ props.item.accountName }}</v-btn>
              <td class="no-wrap">
                {{ props.item.imei }}
                <v-tooltip top v-if="props.item.imei">
                  <v-icon
                    slot="activator"
                    small
                    class="copy-icon"
                    :color="copiedKey === 'imei-' + props.item.id ? 'success' : ''"
                    @click.stop="copyToClipboard(props.item.imei, 'imei-' + props.item.id)"
                    >{{ copiedKey === 'imei-' + props.item.id ? 'check' : 'content_copy' }}</v-icon
                  >
                  <span>Sao chép IMEI</span>
                </v-tooltip>
              </td>
              <td class="no-wrap">
                {{ props.item.deviceType }}
                <v-tooltip top v-if="props.item.deviceType">
                  <v-icon
                    slot="activator"
                    small
                    class="copy-icon"
                    :color="copiedKey === 'deviceType-' + props.item.id ? 'success' : ''"
                    @click.stop="copyToClipboard(props.item.imei + ' - ' + props.item.deviceType, 'deviceType-' + props.item.id)"
                    >{{ copiedKey === 'deviceType-' + props.item.id ? 'check' : 'content_copy' }}</v-icon
                  >
                  <span>Sao chép IMEI - Loại thiết bị</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.planCode }}</td>
              <td>{{ props.item.simPhone }}</td>
              <td>{{ props.item.simSN }}</td>
              <td class="no-wrap">
                {{ props.item.plate }}
                <v-tooltip top v-if="props.item.plate">
                  <v-icon
                    slot="activator"
                    small
                    class="copy-icon"
                    :color="copiedKey === 'plate-' + props.item.id ? 'success' : ''"
                    @click.stop="copyToClipboard(props.item.plate, 'plate-' + props.item.id)"
                    >{{ copiedKey === 'plate-' + props.item.id ? 'check' : 'content_copy' }}</v-icon
                  >
                  <span>Sao chép biển số</span>
                </v-tooltip>
              </td>
              <td class="no-wrap">{{ getDateFormatted(props.item.activatedDate) }}</td>
              <td class="no-wrap">{{ getDateFormatted(props.item.createdDate) }}</td>
              <td>
                <div class="text-xs-center">
                  <v-menu offset-y>
                    <v-btn icon flat slot="activator" color="primary">
                      <v-icon>expand_more</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in menu"
                        :key="index"
                        @click="item.click(props.item)"
                      >
                        <v-list-tile-title>
                          <v-icon class="menu-item-icon">{{item.icon}}</v-icon>
                          <span>{{item.title}}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Context Menu -->
    <vue-context ref="contextMenu" v-if="loggedUser.isProvider">
      <v-list>
        <v-list-tile v-for="(item, index) in menu" :key="index" @click="item.click()">
          <v-list-tile-title>
            <v-icon class="menu-item-icon">{{item.icon}}</v-icon>
            <span>{{item.title}}</span>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </vue-context>
    <!-- Context Menu -->

    <!-- Dialog -->
    <div class="text-xs-center" v-if="selectedItem && loggedUser.isProvider">
      <v-dialog v-model="changePackageDialog" width="360">
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>Đổi gói cước</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="changePackageDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-card-text>
              <v-form v-model="form.valid" ref="form">
                <v-radio-group v-model="form.isChangeBatch" column>
                  <v-radio label="Chỉ đổi thiết bị này" :value="false"></v-radio>
                  <v-radio label="Đổi nhiều thiết bị" :value="true"></v-radio>
                </v-radio-group>
                <v-text-field
                  label="IMEI"
                  :value="selectedItem.imei"
                  v-if="!form.isChangeBatch"
                  disabled
                ></v-text-field>
                <v-textarea
                  label="IMEI"
                  v-model="form.imeiStr"
                  v-if="form.isChangeBatch"
                  :rules="[validate.required]"
                ></v-textarea>
                <v-text-field label="Gói cước hiện tại" :value="selectedItem.planCode" disabled></v-text-field>
                <v-select
                  :rules="[validate.required]"
                  :items="filterdPlanCodes"
                  v-model="form.planCode"
                  label="Gói cước mới"
                ></v-select>
                <v-text-field label="Ghi chú" v-model="form.remark"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                round
                block
                color="primary"
                dark
                @click="changePlanCodeSubmit()"
                :loading="form.isLoading"
              >Đổi gói cước</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-xs-center" v-if="selectedItem && loggedUser.isProvider">
      <v-dialog v-model="renewDialog" width="360">
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>Gia hạn dịch vụ</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="renewDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-card-text>
              <v-form v-model="renewForm.valid" ref="renewForm">
                <v-text-field label="IMEI" :value="selectedItem.imei" disabled></v-text-field>
                <v-text-field label="Gói cước" :value="selectedItem.planCode" disabled></v-text-field>
                <v-text-field
                  label="Ngày kích hoạt"
                  :value="getDateFormatted(selectedItem.activatedDate)"
                  disabled
                ></v-text-field>

                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  full-width
                >
                  <template slot="activator">
                    <v-text-field
                      v-model="renewForm.renewalDate"
                      label="Ngày gia hạn"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="renewForm.renewalDate" @input="menu2 = false"></v-date-picker>
                </v-menu>

                <!-- <v-text-field label="Ngày gia hạn" :value="moment().format('YYYY-MM-DD')"></v-text-field> -->
                <v-text-field
                  label="Phiếu Odoo"
                  v-model="renewForm.odooCode"
                  :rules="[validate.required]"
                ></v-text-field>
                <v-text-field label="Ghi chú" v-model="renewForm.remark"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                round
                block
                color="primary"
                dark
                @click="renewSubmit()"
                :loading="renewForm.isLoading"
              >Gia hạn dịch vụ</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
    <!-- Dialog -->
    <dialog-show-barcode ref="dialogBarcode" />
    <dialog-history ref="dialogHistory" />
  </div>
</template>

<script>
import XLSX from 'xlsx';
import validate from '@/utils/validate';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import * as Utils from '@/utils';
import { VueContext } from 'vue-context';
import moment from 'moment';
import DialogShowBarcode from './DialogShowBarcode';
import DialogHistory from './DialogHistory';

export default {
  components: {
    VueContext,
    DialogShowBarcode,
    DialogHistory
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    },
    totalItems: {
      type: Number,
      default: 0
    },
    isFilter: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      moment: moment,
      validate: validate,
      table: {
        searchText: '',
        headers: [
          {
            text: 'Nhà phân phối / Đại lý',
            value: 'dealerName'
          },
          {
            text: 'Khách hàng',
            value: 'accountName'
          },
          {
            text: 'IMEI',
            value: 'imei'
          },
          {
            text: 'Loại TB',
            value: 'deviceType'
          },
          {
            text: 'Gói cước',
            value: 'planCode'
          },
          {
            text: 'SĐT Sim',
            value: 'simPhone'
          },
          {
            text: 'ICCID',
            value: 'simSN'
          },
          {
            text: 'Biển số',
            value: 'plate'
          },
          {
            text: 'Ngày kích hoạt',
            value: 'activatedDate'
          },
          {
            text: 'Ngày tạo',
            value: 'createdDate'
          },
          {
            text: '',
            value: '#'
          }
        ]
      },
      menu: [
        {
          title: 'Gửi lệnh',
          icon: 'tap_and_play',
          click: item => {
            this.sendCommand(item);
          }
        },
        {
          title: 'Đổi gói cước',
          icon: 'swap_horiz',
          click: item => {
            if (item) this.selectedItem = item;
            this.changePackageDialog = true;
          }
        },
        {
          title: 'Gia hạn dịch vụ',
          icon: 'cached',
          click: item => {
            if (item) this.selectedItem = item;
            this.renewDialog = true;
          }
        },
        {
          title: 'Hiển thị Barcode',
          icon: 'code',
          click: item => {
            if (item) this.selectedItem = item;
            console.log('data -> this.selectedItem', this.selectedItem);
            this.$refs.dialogBarcode.open(this.selectedItem.imei);
          }
        },
        {
          title: 'Lịch sử thiết bị',
          icon: 'history',
          click: item => {
            if (item) this.selectedItem = item;
            this.$refs.dialogHistory.open(this.selectedItem);
          }
        }
      ],
      menu2: false,
      datasourceFiltered: [],
      copiedKey: null,
      copiedTimer: null,
      selectedItem: null,
      changePackageDialog: false,
      renewDialog: false,
      planCodes: ['MOTO1T', 'MOTO1Y', 'MOTOTR'],
      form: {
        isChangeBatch: false,
        valid: false,
        imeiStr: '',
        imeis: [],
        planCode: '',
        remark: '',
        isLoading: false
      },
      renewForm: {
        deviceId: '',
        renewalDate: moment().format('YYYY-MM-DD'),
        remark: '',
        odooCode: '',
        valid: false,
        isLoading: false
      },
      paginationSync: { // Pagination cho table
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      params: { // Params dùng để lấy danh sách
        keySearch: '',
        pageIndex: 1,
        pageSize: 10,
        deviceTypeFilter: 'All',
        planCodeFilter: 'All',
        activedFilter: 'All'
      }
    };
  },

  computed: {
    ...mapGetters(['loggedUser']),

    filterdPlanCodes () {
      if (this.selectedItem) {
        return this.planCodes.filter(
          a =>
            a !==
            (this.selectedItem.planCode &&
              this.selectedItem.planCode.toUpperCase())
        );
      }
      return this.planCodes;
    }
  },

  watch: {
    datasource () {
      this.datasourceFiltered = this.datasource;
    },
    'selectedItem.imei' () {
      if (!this.form.isChangeBatch) {
        this.changeSelectedImei();
      }
    },
    'form.imeiStr' () {
      if (this.form.isChangeBatch && this.form.imeiStr) {
        this.splitStrToArray();
      }
    },
    'form.isChangeBatch' () {
      if (!this.form.isChangeBatch) {
        this.changeSelectedImei();
      } else {
        this.splitStrToArray();
      }
    }
  },

  methods: {
    ...mapActions(['changePlanCode', 'renew']),
    ...mapMutations(['UPDATE_DEVICE_PLAN_CODE']),

    getAccountDetailLink: accountId => `/account/detail?accountId=${accountId}`,

    getDateFormatted: value => {
      return value ? new Date(value).toISOString().slice(0, 10) : '';
    },

    exportToExcel () {
      this.$emit('exportFile');
    },

    copyToClipboard (text, key) {
      if (!text) return;

      const markCopied = () => {
        this.copiedKey = key;
        clearTimeout(this.copiedTimer);
        this.copiedTimer = setTimeout(() => {
          if (this.copiedKey === key) this.copiedKey = null;
        }, 1500);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(markCopied).catch(() => {});
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand('copy');
        markCopied();
      } catch (err) {
        // ignore
      }
      document.body.removeChild(textarea);
    },

    filterData () {
      this.params.pageIndex = 1;

      // Set page = 1 cho table khi được filter
      this.paginationSync.page = 1;

      this.$emit('changePage', this.params);
    },

    openContextMenu (event, item) {
      this.selectedItem = item;
      if (this.loggedUser.isProvider) {
        this.$refs.contextMenu.open(event);
      }
    },

    sendCommand (item) {
      if (item) this.selectedItem = item;

      let deviceId = this.selectedItem.id;
      let deviceType = this.selectedItem.deviceType || '';
      let imei = this.selectedItem.imei;
      let simPhone = this.selectedItem.simPhone;
      let plate = this.selectedItem.plate;
      window.open(
        `#/monitor?deviceId=${deviceId}&imei=${imei}&plate=${plate}&deviceType=${deviceType}&simPhone=${simPhone}`
      );
    },

    changePlanCodeSubmit () {
      if (this.form.valid) {
        this.form.isLoading = true;
        this.changePlanCode(this.form)
          .then(_ => {
            this.form.isLoading = false;
            this.changePackageDialog = false;
            this.selectedItem.planCode = this.form.planCode;
            window.getApp.showMessage('Chuyển gói cước thành công');

            let items = [];
            if (!this.form.isChangeBatch) {
              items.push(this.selectedItem);
            } else {
              this.form.imeis.map(a => {
                let item = {
                  imei: a,
                  planCode: this.form.planCode
                };
                items.push(item);
                return 0;
              });
            }
            this.UPDATE_DEVICE_PLAN_CODE(items);
          })
          .catch(_ => {
            this.form.isLoading = false;
            this.changePackageDialog = false;
            window.getApp.showMessage('Chuyển gói cước thất bại', 'error');
          });
      } else {
        this.$refs.form.validate();
      }
    },

    changeSelectedImei () {
      this.form.imeis = [];
      this.form.imeis.push(this.selectedItem.imei);
    },

    splitStrToArray () {
      let arr = this.form.imeiStr.split('\n');
      this.form.imeis = [];
      arr.map(a => {
        if (a) this.form.imeis.push(a.trim());
        return 0;
      });
    },

    search () {
      let searchText = this.table.searchText.trim();
      this.params.keySearch = searchText;
      this.params.pageIndex = 1;

      // Set page = 1 cho table khi được filter
      this.paginationSync.page = 1;

      this.$emit('changePage', this.params);
    },

    renewSubmit () {
      let obj = Object.assign({}, this.renewForm);
      obj.deviceId = this.selectedItem.id;
      obj.renewalDate = moment(this.renewForm.renewalDate).valueOf();

      if (this.renewForm.valid) {
        this.renewForm.isLoading = true;
        this.renew([obj])
          .then(result => {
            this.renewForm.isLoading = false;
            this.renewDialog = false;
            if (result && result.failList && result.failList.length > 0) {
              let error = result.failList[0];
              window.getApp.showMessage(`Gia hạn dịch vụ thất bại: ${error.errCode}`, 'error');
            } else {
              window.getApp.showMessage('Gia hạn dịch vụ thành công', 'success');
              this.$emit('changePage', this.params);
              this.$emit('renewed');
            }
          })
          .catch(_ => {
            this.renewForm.isLoading = false;
            this.renewDialog = false;
            window.getApp.showMessage('Gia hạn dịch vụ thất bại', 'error');
          });
      } else {
        this.$refs.renewForm.validate();
      }
    },

    changePage (pagination) {
      this.params.pageIndex = pagination.page;
      this.params.pageSize = pagination.rowsPerPage;
      this.$emit('changePage', this.params);
    }
  }
};
</script>

<style scoped>
.v-card__text {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.link-button {
  min-width: 0px !important;
  margin-left: 15px !important;
}
.dealer-name {
  min-width: 0px !important;
  margin-left: -8px !important;
}
.account-name {
  margin-top: 10px;
}
.filter-title {
  margin-top: 12px;
}
.copy-icon {
  font-size: 16px;
  cursor: pointer;
  vertical-align: middle;
  margin-left: 4px;
  opacity: 0.6;
}
.copy-icon:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/device/components/list.vue